import React from 'react'
import { format } from 'date-fns'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { LGYAddress } from 'app/components/util/lgy-field/LgyField'

const AppraisalDescriptionSection = ({ assignmentDetails }) =>
  <LgySubsection header='Assignment Description' className='assignment-details-child'>
    <table>
      <caption className='usa-sr-only'>Assignment Description</caption>
      <tbody>
        <tr>
          <th scope='row'>Address:</th>
          <td>
            <LGYAddress
              streetNumber={assignmentDetails.streetNumber}
              streetAddress1={assignmentDetails.addressOne}
              streetAddress2={assignmentDetails.addressTwo}
              city={assignmentDetails.city}
              state={assignmentDetails.state}
              zip={assignmentDetails.zip}
              zipSuffix={assignmentDetails.zipSuffix} />
          </td>
        </tr>
        <tr>
          <th scope='row'>County:</th>
          <td>{assignmentDetails.county}</td>
        </tr>
        <tr>
          <th scope='row'>Legal description:</th>
          <td>{assignmentDetails.legalText}</td>
        </tr>
        <tr>
          <th scope='row'>Proposed/existing structure:</th>
          <td>{assignmentDetails.proposedExistingCode}</td>
        </tr>
        {/*Only display the Loan Use field for IND and LAP appraisals*/}
        {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND') &&
          <tr>
            <th scope='row'>Loan Use:</th>
            <td>{assignmentDetails.loanUse}</td>
          </tr>}
        <tr>
          <th scope='row'>Request received date:</th>
          <td>{format(assignmentDetails.createdDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
        </tr>
      </tbody>
    </table>
  </LgySubsection>

export default AppraisalDescriptionSection
